import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  TextField,
  Snackbar,
  Grid,
  Alert, // Added Alert
} from "@mui/material";
import useFirestore from "../../../../config/fireBaseHook"; // Import useFirestore
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ModalActions from "../../../common/ModalActions";

const Add = ({ onRecordAdded }) => {
  const { addData: addFirestoreData } = useFirestore("ElearnShellTerm"); // Use Firestore hook
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const initialFormData = {
    Term: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    setSnackbarMessage("");
    try {
      await addFirestoreData(formData); // addData from useFirestore handles createdAt
      setSnackbarMessage("Term added successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setFormData(initialFormData);
      setOpen(false);
      onRecordAdded(); // Call the callback function to refresh the list
    } catch (error) {
      console.error("Error adding record:", error);
      setSnackbarMessage(`Error adding term: ${error.message}`);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        variant="contained"
        color="success"
        onClick={() => setOpen(true)}
        sx={{ marginBottom: "10px", color: "white" }}
      >
        Add Term
      </Button>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <ModalDialogTitle onClose={handleClose}>Add Term</ModalDialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Term"
                name="Term"
                value={formData.Term}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <ModalActions onSave={handleSubmit} saving={loading} />
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Add;
